import { render, staticRenderFns } from "./BusComponent.vue?vue&type=template&id=3a3727d8&scoped=true&"
import script from "./BusComponent.vue?vue&type=script&lang=js&"
export * from "./BusComponent.vue?vue&type=script&lang=js&"
import style0 from "./BusComponent.vue?vue&type=style&index=0&id=3a3727d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3727d8",
  null
  
)

component.options.__file = "BusComponent.vue"
export default component.exports